import { useEffect } from 'react';
import { pick } from 'lodash';
import pendoQuery from 'API/handlers/pendoQuery';
import getUserData from 'utils/user';

declare global {
  interface Window {
    pendo: any;
  }
}

const addPrefixToObjectKeys = (obj: any, prefix: string) => {
  const newObj: Record<string, any> = {};
  Object.keys(obj).forEach((key) => {
    newObj[`${prefix}_${key}`] = obj[key];
  });
  return newObj;
};

export default function useInitPendo() {
  const { accountIsSuspended, guestyAccountId, ypaUserId } =
    getUserData() || {};

  useEffect(() => {
    if (accountIsSuspended) return;

    (async () => {
      const { data: pendoData } = await pendoQuery();
      const userInfo = pick(getUserData(), [
        'inTrial',
        'subscribed',
        'dayOfTrial',
        'trialEndDate',
      ]);
      const pendoUserInfo = addPrefixToObjectKeys(userInfo, 'gfh');
      const pendoAccountInfo = addPrefixToObjectKeys(pendoData, 'gfh');
      const visitor = { id: ypaUserId };
      const account = {
        id: guestyAccountId,
        ...pendoUserInfo,
        ...pendoAccountInfo,
      };

      window.pendo.initialize({ visitor, account });
    })();
  }, [accountIsSuspended]);

  return null;
}
